import React from "react";
import Container from "../../elements/Container";
import HeadingTitle from "../../elements/displayTitles/HeadingTitle";
import Heading from "../../elements/displayTitles/Heading";
import Button from "../../elements/Button";
import Product1 from "../../../assets/img/Burgers/Product-1.jpg";
import Product2 from "../../../assets/img/Burgers/Product-2.jpg";
import Product3 from "../../../assets/img/Burgers/Product-3.jpg";

export default function Products() {
   return (
      <Container>
         <HeadingTitle variant="h3">Toujours de délicieux Burgers</HeadingTitle>
         <Heading theme="title" position="center" className="my-5">Choisissez et savourez</Heading>
         <p className="text-center">
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptas
            laudantium, dolores explicabo cupiditate fuga ratione, ex mollitia
            ut dicta et, facilis sit sequi tempora eveniet. Fugit distinctio
            nesciunt libero non.
         </p>
         {/* Products */}
         <div className="flex flex-col gap-y-5 sm:grid sm:grid-cols-3 mt-10 mb-20 sm:gap-x-2">
            {/* Product 1 */}
            <div className="w-full h-full ">
               {/* Illustration */}
               <div className="relative w-full h-80">
                  {/* Text-hover */}
                  <div className="flex flex-col items-center justify-center z-10 relative h-full bg-gray-800/90 opacity-0 hover:opacity-95 text-white">
                     <div className="flex gap-4 items-center">
                        <p>Access the course</p>
                     </div>
                  </div>
                  <img
                     src={Product1}
                     alt=""
                     className="bg-primary absolute top-0 left-0 h-full w-full object-cover"
                  />
               </div>
               {/* Description */}
               <div className="flex flex-col items-center px-5 pb-2">
                  <Heading variant="h3" theme="secondary">
                     Le rustique
                  </Heading>
                  <p className="text-center">
                     Lorem ipsum dolor sit amet consectetur adipisicing elit.
                     Libero, perspiciatis.
                  </p>
                  <Button color="danger">Commandez</Button>
               </div>
            </div>
            {/* Product 2 */}
            <div className="w-full h-full">
               {/* Illustration */}
               <div className="relative w-full h-80">
                  {/* Text-hover */}
                  <div className="flex flex-col items-center justify-center z-10 relative h-full bg-yellow-400 opacity-0 hover:opacity-95 animate text-white">
                     <div className="flex gap-4 items-center">
                        <p>Access the course</p>
                     </div>
                  </div>
                  <img
                     src={Product2}
                     alt=""
                     className="bg-primary absolute top-0 left-0 h-full w-full object-cover"
                  />
               </div>
               {/* Description */}
               <div className="flex flex-col items-center px-5 pb-2">
                  <Heading variant="h3" theme="secondary">
                     Le double-cheese
                  </Heading>
                  <p className="text-center">
                     Lorem ipsum dolor sit amet consectetur adipisicing elit.
                     Libero, perspiciatis.
                  </p>
                  <Button color="danger">Commandez</Button>
               </div>
            </div>
            {/* Product 3 */}
            <div className="w-full h-full">
               {/* Illustration */}
               <div className="relative w-full h-80">
                  {/* Text-hover */}
                  <div className="flex flex-col items-center justify-center z-10 relative h-full bg-yellow-400 opacity-0 hover:opacity-95 animate text-white">
                     <div className="flex gap-4 items-center">
                        <p>Access the course</p>
                     </div>
                  </div>
                  <img
                     src={Product3}
                     alt=""
                     className="bg-primary absolute top-0 left-0 h-full w-full object-cover"
                  />
               </div>
               {/* Description */}
               <div className="flex flex-col items-center px-5 pb-2">
                  <Heading variant="h3" theme="secondary">
                     Le veggie
                  </Heading>
                  <p className="text-center">
                     Lorem ipsum dolor sit amet consectetur adipisicing elit.
                     Libero, perspiciatis.
                  </p>
                  <Button color="danger">Commandez</Button>
               </div>
            </div>
         </div>
      </Container>
   );
}
